<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Share1`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.5 2.25L21.5 11.25L12.5 19.75V14.25C5.5 14.25 2.5 21.75 2.5 21.75C2.5 13.25 5 7.75 12.5 7.75V2.25Z" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconShare1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
